import clsx from 'clsx';

interface VerticalTimelineProps {
  color?: string; // tailwind color class
  className?: string;
  size?: 'small' | 'medium' | 'large';
}

const SIZE_CLASSES = {
  small: { line: 'w-2.5', dot: 'h-2.5 w-2.5' },
  medium: { line: 'w-3', dot: 'h-3 w-3' },
  large: { line: 'w-4', dot: 'h-4 w-4' },
} as const;

export const VerticalTimeline = ({
  color = 'bg-slate-400',
  className = '',
  size = 'medium',
}: VerticalTimelineProps) => {
  const { line, dot } = SIZE_CLASSES[size];

  return (
    <div className={clsx('relative flex shrink-0 justify-center self-stretch', line, className)}>
      <span className={clsx('absolute inset-y-0 w-px', color)} aria-hidden />
      <span className={clsx('my-auto shrink-0 rounded-full', dot, color)} aria-hidden />
    </div>
  );
};
